import type { Channel } from '@core/channel'

export type SubscriptionFlagKeys =
  '50_percent_traffic_widget_display' | '95_percent_traffic_widget_display'

/**
 * Returns subscription flags for the given channel.
 * @param params
 */
export function useSubscriptionFlags(channel: Channel | null): {
  [key in SubscriptionFlagKeys]?: boolean
} {
  return channel?.config?.subscription_flags ?? {}
}
